import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AppContext from "../../AppContext";

import plusimgicon from "../../assets/media/icons/gallery.png";
import trahsicon from "../../assets/media/icons/trashRed.png";

import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

//import AdminNavbar from "./navbar/AdminNavbar";

import { MDBCheckbox } from "mdb-react-ui-kit";

function FileUpload() {
  const buttonRef = useRef();
  const inputRef = useRef();
  const descriptionRef = useRef();
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const [pdfs, setPdfs] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [titleEn, setTitleEn] = useState("");
  const [titleEs, setTitleEs] = useState("");
  const [descriptionEn, setDescriptionEn] = useState("");
  const [descriptionEs, setDescriptionEs] = useState("");
  const [tags, setTags] = useState([]);
  const [sellPriceFull, setSellPriceFull] = useState(0);
  const [sellPriceDiscounted, setSellPriceDiscounted] = useState(0);
  const [checked, setChecked] = useState(false);
  const [checked_2, setChecked_2] = useState(false);
  const [checked_3, setChecked_3] = useState(false);
  const [checked_4, setChecked_4] = useState(false);
  const [checked_5, setChecked_5] = useState(false);
  const location = useLocation();
  const filename = location.state?.filename;

  useEffect(() => {
    onGetProductById();
  }, [filename]);

  const onGetProductById = () => {
    console.log(filename);
    context.interAxios.get("/storage/pdf/" + filename + ".pdf", function (response) {
      console.log(response.data);
    });
  };
  // const quill = new Quill("#editor");

  const onFileChange = (e) => {
    let list = selectedFiles;
    for (let i = 0; i < e.target.files.length; i++) {
      list.push(e.target.files[i]);
    }
    setPdfs(list.map((file) => ({ url: URL.createObjectURL(file), name: file.name })));
    console.log(list);
    setSelectedFiles(list);
  };

  const renderPhotos = (source) => {
    return source.map((photo) => {
      console.log(photo);
      return (
        <div className="photos" key={photo.url}>
          <Document file={photo.url} error={"Hiányzó PDF fájl"} loading={"Fájl betöltése"}>
            <Page pageNumber={1} renderTextLayer={true} renderAnnotationLayer={false} scale={1} />
          </Document>
          <button className="trashbutton" color="elegant" onClick={() => onResetPhotos(photo.name)}>
            <img src={trahsicon} style={{ width: "60%" }} className="py-1" />
          </button>
        </div>
      );
    });
  };

  const onResetPhotos = (photo) => {
    var photos = [];
    for (let j = 0; j < selectedFiles.length; j++) {
      if (selectedFiles[j].name !== photo) {
        photos.push(selectedFiles[j]);
      }
    }
    setPdfs(photos.map((file) => ({ url: URL.createObjectURL(file), name: file.name })));
    setSelectedFiles(photos);
  };

  const handleChoose = (event) => {
    event.preventDefault();
    inputRef.current.click();
  };

  const handleSaveImage = (e) => {
    e.preventDefault();

    if (selectedFiles.length > 0) {
      let prom = [];
      let array = selectedFiles;
      for (let i = 0; i < selectedFiles.length; i++) {
        const formData = new FormData();
        formData.append("file", selectedFiles[i], filename);
        console.log(formData);
        prom.push(
          context.interAxios.put(
            "/storage/pdf/" + filename + ".pdf",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
            function (response) {
              console.log(response.data);
              //array[i] = response.data.id;
            },
          ),
        );
      }
      Promise.all(prom).then(() => {
        setPdfs([]);
        setSelectedFiles([]);
        alert("Sikeres mentés");
      });
    }
  };

  return (
    <div className="addbike-container">
      <form onSubmit={(e) => handleSaveImage(e)} className="profile-form" autoComplete="off">
        <div className="add-image">
          <p className="add-image-title">PDF fájl feltöltése:</p>
          <div className="pdfs-list">
            {renderPhotos(pdfs)}
            {pdfs.length === 0 && (
              <div className="add-image-div">
                <img
                  src={plusimgicon}
                  style={{ width: "55px", paddingTop: "0.8rem" }}
                  onClick={(e) => handleChoose(e)}
                />
                <input ref={inputRef} className="FileInput_input" type="file" accept=".pdf" onChange={onFileChange} />
              </div>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-start py-4">
          <button type="submit" className="normal-button" ref={buttonRef}>
            <span>Mentés</span>
          </button>
        </div>
      </form>
    </div>
  );
}

export default FileUpload;
